export enum PhoneSmsOtpAuthScreenNames {
  PHONE_LOGIN_SCREEN = 'Phone Login Screen',
  VERIFY_SMS_OTP = 'Verify SMS OTP',
}

export type PhoneSmsOtpAuthScreenName =
  (typeof PHONE_SMS_OTP_AUTH_CUSTOM_SCREEN_NAMES)[number];

export const PHONE_SMS_OTP_AUTH_SCREEN_IDS = {
  PHONE_LOGIN_SCREEN: 'SC3EZ5tQIn5mwbpoHFg1uD0FUm5NV',
  VERIFY_SMS_OTP: 'SC3EZ50YYNf6s9I6UMYW7LLvnlrvK',
} as const;

export const PHONE_SMS_OTP_AUTH_CUSTOM_SCREEN_NAMES = [
  PhoneSmsOtpAuthScreenNames.PHONE_LOGIN_SCREEN,
  PhoneSmsOtpAuthScreenNames.VERIFY_SMS_OTP,
] as const;

export const isPhoneSmsOtpAuthScreen = (
  screenName: string
): screenName is PhoneSmsOtpAuthScreenName =>
  PHONE_SMS_OTP_AUTH_CUSTOM_SCREEN_NAMES.includes(
    screenName as PhoneSmsOtpAuthScreenName
  );
